const my_profile = {
  viewMyClubSeacretProfile: "查看我的 ClubSecret 个人资料", // translated
  viewMoreDetails: "查看更多详情", // translated
  verifiedEmail: "已验证的电子邮件", // translated
  unverifiedEmail: "未经验证的电子邮件", // translated
  pointsIn: "点入", // translated
  balance: "平衡", // translated
  pointsOut: "指出", // translated
  pointsHistoryTable: "积分历史表", // translated
  topUp: "充值", // translated
};

export default my_profile;
